import template from './registration-simple.jade';
import validation from '../../../scripts/services/validation';

const CianMediaAuthentication = window.CianMediaAuthentication;

export default () => {
  return {
    require: ['cianAfRegistrationSimple', 'form'],
    template,
    scope: {},
    bindToController: {
      mergeData: '=',
      enterEmailData: '=',
    },
    link: (scope, element, attrs, ctrls) => {
      ctrls[0].init(ctrls[1]);
    },
    controller: function (
      $q, $log, $http, $timeout, apiService, remoteValidationService, userService, analyticsService, geoService,
      addFormService, homeownerService, deviceService, commercialOwnerService
    ) {
      'ngInject';

      this.isMobile = deviceService.isMobile;

      this.init = form => {

        this.passwordErrorMessage = '';
        this.isOpenTooltipPasswordError = false;

        this.outerValidatorPassword = () => {
          $http.post(
            '/cian-api/site/v1/validate-password/',
            { password: this.data.password || '' },
            { allowServerErrors: true }
          )
          .then(response => {
            this.passwordErrorMessage = response.data && response.data.message || '';
            this.isOpenTooltipPasswordError = !!response.data.message;
          })
          .catch(error => {
            this.passwordErrorMessage = error.data && error.data.message || 'Ошибка на сервере';
            this.isOpenTooltipPasswordError = true;
          });
        }

        this.data = {
          enableSubscription: true,
          isProfessional: false,
          password: '',
          email: '',
        };

        form.remoteValidator = remoteValidationService.getInstance(form);
        form.remoteValidator.map = data => {
          const result = {
            fields: {},
            form: {},
            sections: {},
          };

          // todo define errors variable
          if (data && data.hasOwnProperty('errors')) {
            /**
             * TODO попросить бекенд изменить формат ошибки
             */
            angular.forEach(data.errors, (value) => {
              let fieldName = '';
              if (value.code === 'EmailAlreadyExists') {
                fieldName = 'email';
              } else {
                fieldName = value.key.replace('request.', '');
              }
              result.fields[fieldName] = {
                triggers: fieldName,
                messages: value,
              };
            });
          } else if (errors) { // eslint-disable-line
            angular.forEach(errors, (value, key) => { // eslint-disable-line
              result.fields[key] = {
                triggers: key,
                messages: value,
              };
            });
          }

          return result;
        };

        this.passwordValidation = '';

        this.emailValidation = validation(form, 'email', {
          required: 'Не заполнен "E-mail"',
          email: 'Некорректный "E-mail"',
          /**
           * TODO
           * Такой пользователь уже зарегистрирован. Попробуйте войти (ссылка на логин)
           */
        });

        this.passIsShown = false;

        this.togglePassVisible = () => {
          this.passIsShown = !this.passIsShown;
        }

        this.requestInProcess = false;
        this.socialSubmiting = false;
        this.submit = () => {
          analyticsService.trySubmitRegistration();

          if (this.form.$invalid) {
            $timeout(() => {
              this.form.remoteValidator.scrollToFirstError();
            }, 200);
            return;
          }
          this.requestInProcess = true;
          form.$setPristine();
          apiService.registerUserSimple(this.data).then((response) => {
            window.ca && ca('event', {
              name: 'oldevent',
              category: 'Registration',
              action: analyticsService.adAnalyticsState,
              label: this.data.isProfessional ? 'agent' : 'user'
            });

            CianMediaAuthentication // eslint-disable-line
              .Authenticate({ // eslint-disable-line
                logOnInfo: response.data.logOnInfo,
                login: response.data.login,
                onComplete() {
                  $q.all([
                    apiService.getUser(),
                    apiService.getUserGeo(),
                    apiService.canPublishAsHomeowner({params: {realtyOfferId: addFormService.ad && addFormService.ad.id}}),
                    commercialOwnerService.canPublishAsCommercialOwner(),
                  ])
                    .then(([userData, geoData, canPublishAsHomeowner, canPublishAsCommercialOwner]) => {
                      homeownerService.userCanPublishThisOfferAsHomeowner = canPublishAsHomeowner;
                      homeownerService.setUserCanPublishAsCommercialOwner(canPublishAsCommercialOwner);
                      addFormService.ad.isByHomeowner = canPublishAsHomeowner && addFormService.ad.isByHomeowner;

                      const user = userData.data.data;
                      userService.setUser(user, true);

                      const userGeo = geoData.data.data;
                      analyticsService.authUser(user.cianUserId, user.email);
                      if (userGeo) geoService.setUserGeo(userGeo);
                      form.$setPristine();
                      this.requestInProcess = false;
                    }).catch(err => {
                      $log.error(err);
                      this.requestInProcess = false;
                    });
                },
              });
          }, response => {
            if (response.status === 400) {
              if (response.data) {
                this.passwordErrorMessage = '';
                this.isOpenTooltipPasswordError = false;

                form.remoteValidator.setValidators(response.data);
              }
            }
            this.requestInProcess = false;
          });
        };
      };
    },
    controllerAs: 'regSimpleCtrl',
    replace: true,
  };
};
